import React from 'react'
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material'
import EditPencilIcon from '../../Common/Icon/EditPencilIcon'
import { ClipboardList } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export default function NodeMenu ({ handleCompliancePreview, anchorElMenu, openMenu, handleCloseMenu, data }) {
    const navigate = useNavigate() // Hook for navigation
    const tranferComplianceNavigator = () => {
        const SelectedNodeData = handleCompliancePreview()
        // Navigate to Compliance Preview page
        navigate(`/GRC/${SelectedNodeData.displayName}/body-preview?userId=${SelectedNodeData.userId}&bodyType=1&matrix=2`)
    }
    // const levelName = (level) => {
    //     switch (level) {
    //     case 2:

    //         return { name: 'Body', route: 'body-preview' }
    //     case 3:

    //         return { name: 'Compliance', route: 'compliance-preview' }

    //     default:
    //         return 'NA'
    //     }
    // }
    return (
        <>
            {/* Menu Component */}
            <Menu
                anchorEl={anchorElMenu}
                open={openMenu}
                onClose={handleCloseMenu}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
            >
                {/* Edit User Option */}
                <MenuItem
                    onClick={() => {
                        data?.handleEditDrawerOpen(data)
                        handleCloseMenu()
                    }}
                >
                    <ListItemIcon>
                        {/* <EditIcon fontSize="small" /> */}
                        <EditPencilIcon />
                    </ListItemIcon>
                    <ListItemText primary="Edit User" />
                </MenuItem>

                {/* Compliance Preview Option */}
                <MenuItem
                    onClick={() => {
                        // navigate('/GRC/compliance-preview', { state: { complianceData: data } }) // Pass data via state
                        // data?.handleCompliancePreview(data)
                        tranferComplianceNavigator()
                        handleCloseMenu()
                    }}
                >
                    <ListItemIcon>
                        <ClipboardList fontSize="small" color='#007876' />
                    </ListItemIcon>
                    <ListItemText primary={'Preview'} />
                </MenuItem>
            </Menu>
        </>
    )
}
